import { useEffect, useState } from 'react';
import { eventBus } from '../bus/eventBus';
import { listPendingOrders } from './pendingOrders';

// Tracks browser connectivity plus the offline sales queue, so any component
// can show "Hors ligne" / "N ventes en attente" without re-deriving it.
export default function useOnlineStatus() {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [syncing, setSyncing] = useState(false);
    const [pendingCount, setPendingCount] = useState(0);

    useEffect(() => {
        const handleOnline = () => setIsOnline(true);
        const handleOffline = () => setIsOnline(false);
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        const handleStatus = (payload) => {
            setSyncing(payload.syncing);
            setPendingCount(payload.pendingCount);
        };
        eventBus.on('offlineSyncStatus', handleStatus);

        listPendingOrders().then((orders) => setPendingCount(orders.length)).catch(() => {});

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
            eventBus.off('offlineSyncStatus', handleStatus);
        };
    }, []);

    return { isOnline, syncing, pendingCount };
}
